import ManagedTable, { ManagedColumn, ManagedColumnExtra, ManagedTableProps } from 'app/common/table/ManagedTable';
import TimeUtils from 'app/common/util/TimeUtils';
import { SimulationDto } from 'app/model/CORE';
import React from 'react';
import useWindowDimensions from '../../common/hooks/useWindowDimensions';
import { SimulationUtils } from '../../common/util/SimulationUtils';
import TimePeriodUtils from '../../common/util/TimePeriodUtils';

/* Simulation Columns & Simulation Table definitions */
export class SimulationColumn extends ManagedColumn<SimulationDto> {
    constructor(
        header: string,
        width: string,
        getCellValue: (object: SimulationDto) => any,
        extra?: ManagedColumnExtra<SimulationDto>,
    ) {
        super(header, width, getCellValue, extra);
    }
}

export class StandardSimulationColumn {
    public static readonly TYPE = new ManagedColumn<SimulationDto>('TYPE', '9em', obj =>
        SimulationUtils.getSimulationTypeString(obj.dataset.simulIdentifier),
    );
    public static readonly ID = new ManagedColumn<SimulationDto>('ID', '15em', obj =>
        SimulationUtils.getSimIdentifierString(obj.dataset.simulIdentifier),
    );
    public static readonly NAME = new ManagedColumn<SimulationDto>('NAME', '20em', obj => obj.simulationName);
    public static readonly DESCRIPTION = new ManagedColumn<SimulationDto>('DESC', '15em', obj => obj.description);
    public static readonly PERIOD = new ManagedColumn<SimulationDto>('SIM PERIOD', '12em', obj =>
        TimePeriodUtils.formatDDHHMM(obj.simulationPeriod),
    );
    public static readonly PUBLISH_TIME = new ManagedColumn<SimulationDto>('PUBLISHED', '8em', obj =>
        TimeUtils.formatDDHHMM(obj.publicationTime),
    );
    public static readonly ENGINE_ID = new ManagedColumn<SimulationDto>('ENGINE', '8em', obj => obj.simulationEngineId);
    public static readonly REFERENCE = new ManagedColumn<SimulationDto>('REFERENCE', '8em', obj =>
        SimulationUtils.getDatasetReferenceString(SimulationUtils.getDatasetReference(obj)),
    );
    public static readonly USER = new ManagedColumn<SimulationDto>('USER', '10em', obj =>
        SimulationUtils.isUserManagedSimulation(obj) ? obj.creatorUserId : null,
    );
    public static readonly ANUID = new ManagedColumn<SimulationDto>('ANUID', '10em', obj =>
        SimulationUtils.isUserManagedSimulation(obj) ? obj.creatorAnuId : null,
    );
}

class SimulationTableBase extends ManagedTable<SimulationDto> {}

// I have had to adapt ManagedTable so that it accepts a font size.
// VirtualTable that is behind only accepts column width in "px", whereas our column definition is in "em".
// This usually is not a problem when font size is fixed, but in our case, font size depends on the viewport width.
// When the viewport is resized, the new font size is provided to the flight table, that will adapt column width accordingly.
const SimulationTable = (props: ManagedTableProps<SimulationDto>) => {
    const { width } = useWindowDimensions();
    const fontSize = (0.42 * width) / 100;

    return <SimulationTableBase fontSize={fontSize} {...props} />;
};

export default SimulationTable;
